import { useState } from 'react';
import { SetupWizard, goToAdminSignIn, type SetupLang } from '@matix/ui';
import { useAuthStore } from '../../store/authStore';

/** Same key the login screen persists its language under. */
const LANG_KEY = 'pos:kds:lang';

/**
 * A newly provisioned tenant's first sign-in on the kitchen / service screen:
 * the shared Initial Setup Wizard. Finishing it opens the ADMIN app's sign-in.
 */
export function SetupScreen(): JSX.Element | null {
  const state = useAuthStore((s) => s.state);
  const exitSetup = useAuthStore((s) => s.exitSetup);
  const [lang, setLangState] = useState<SetupLang>(() =>
    typeof window !== 'undefined' && window.localStorage.getItem(LANG_KEY) === 'ar' ? 'ar' : 'en',
  );
  if (state.kind !== 'setup') return null;
  const setLang = (next: SetupLang): void => {
    setLangState(next);
    window.localStorage.setItem(LANG_KEY, next);
  };
  return (
    <SetupWizard
      tenantSlug={state.slug}
      tenantName={state.tenantName}
      setupToken={state.setupToken}
      lang={lang}
      onLangChange={setLang}
      continueLabel={{ en: 'Go to the admin dashboard', ar: 'الانتقال إلى لوحة الإدارة' }}
      // Setting a business up is admin work: finish in the admin app.
      onComplete={() => goToAdminSignIn(state.slug)}
      onExit={exitSetup}
    />
  );
}
